import Head from 'next/head';
import { useState } from "react";
import { useUser } from "../lib/hooks";
import { Button, Input, Text, Container, Row, Spacer } from "@nextui-org/react";
import { useRouter } from "next/router";
import HCaptcha from "@hcaptcha/react-hcaptcha";

import Layout from "../components/layout";

export default function Verify() {
  useUser({ redirectTo: "/", redirectIfFound: true });
  const router = useRouter();

  const [error, setError] = useState("");
  const [hcaptchaToken, setHcaptchaToken] = useState("");

  const requestPasswordReset = async (event) => {
    setError("");
    event.preventDefault();
    const user = event.target.username.value;
    const res = await fetch("/api/auth/startpasswordreset", {
      body: JSON.stringify({
        user,
        hcaptchaToken,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
    });

    const result = await res.json();
    if (res.status === 200) {
      router.push("/login?resetstarted");
      return;
    }
    setError((result && result.error) || "Sorry, something went wrong.");
  };

  return (
    <Layout>
      <Text h1>Request a password reset</Text>
      <form onSubmit={requestPasswordReset} className="submission">
        <Container css={{ maxWidth: 400 }}>
          <Row>
            <Input
              type="text"
              name="username"
              label="Username"
              fullWidth
              required
            />
          </Row>
          <Spacer y={0.5} />
          {process.env.NEXT_PUBLIC_HCAPTCHA_SITEKEY && (
            <>
              <Row>
                <HCaptcha
                  sitekey={process.env.NEXT_PUBLIC_HCAPTCHA_SITEKEY}
                  onVerify={setHcaptchaToken}
                />
              </Row>
              <Spacer y={0.5} />
            </>
          )}
          <Row>
            <Button type="submit">Request password reset</Button>
          </Row>
          <Spacer y={0.5} />
        </Container>
      </form>
      {error && <p className="error">{error}</p>}
    </Layout>
  );
}
